import styled from 'styled-components'

import {Container} from '~/components/general/container/Container'
import {Card} from '~/components/general/card/Card'
import {Button} from '~/components/general/button/Button'

export const PageWrapper = styled(Container).attrs({
  direction: 'column',
  spacing: 2,
  align: 'stretch',
})`
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 16px;
`

export const HeaderCard = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
`

export const HeaderRow = styled(Container).attrs({
  justify: 'space-between',
  align: 'center',
  wrap: true,
  spacing: 2,
})``

export const HeaderCenter = styled(Container).attrs({
  direction: 'column',
  spacing: 1,
  align: 'center',
  justify: 'center',
})`
  text-align: center;
`

export const PartnerInfoGroup = styled(Container).attrs({
  direction: 'column',
  spacing: 1,
})``

export const Logo = styled.img`
  width: 25%;
  height: auto;
  max-width: 320px;
  max-height: 140px;
  object-fit: contain;
  margin: 0 auto;
`

export const DetailsRow = styled(Container).attrs({
  spacing: 2,
  wrap: true,
  align: 'center',
})``

export const Grid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: minmax(300px, 380px) 1fr;
  gap: 16px;
  align-items: stretch;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

export const Column = styled(Container).attrs({
  direction: 'column',
  spacing: 2,
})`
  flex: 1 1 340px;
  min-width: 300px;
  height: 100%;
`

export const DayCard = styled(Card)`
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
  flex: 1 1 auto;
`

export const Footer = styled(Container).attrs({
  flex: true,
  justify: 'center',
  align: 'center',
  spacing: 1,
  wrap: true,
})`
  padding: 24px 0;
  gap: 8px;
  text-align: center;
`

// Calendar styles
export const CalendarCard = styled(Card)`
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
  flex: 1 1 auto;
`

export const CalendarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 8px;
`

export const NavButtonsGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export const NavButton = styled.button`
  border: 1px solid ${({theme}) => theme.colors.inputBorder};
  background: ${({theme}) => theme.colors.white};
  border-radius: ${({theme}) => theme.borderRadius.xs};
  padding: 8px 16px;
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
  color: ${({theme}) => theme.colors.black};
  transition: background 120ms ease-in-out, border-color 120ms ease-in-out;

  &:hover {
    background: ${({theme}) => theme.colors.grey.grey20};
    border-color: ${({theme}) => theme.colors.inputBorder};
  }

  &:active {
    background: ${({theme}) => theme.colors.grey.grey40};
  }

  &:disabled {
    background: ${({theme}) => theme.colors.grey.grey20};
    color: ${({theme}) => theme.colors.grey.grey400};
    border-color: ${({theme}) => theme.colors.grey.grey150};
    cursor: not-allowed;
    opacity: 0.8;
  }
`

export const SelectedGlobal = styled(Container).attrs({
  justify: 'center',
  align: 'center',
})`
  width: 100%;
  text-align: center;
  padding: 24px 0 16px;
`

export const WeekdaysRow = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  padding: 4px 0;
`

export const WeekdayCell = styled.div`
  text-align: center;
`

export const CalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 6px;
`

export const DayCell = styled.button`
  border: 1px solid ${({theme}) => theme.colors.inputBorder};
  background: ${({theme}) => theme.colors.white};
  border-radius: ${({theme}) => theme.borderRadius.xs};
  padding: 8px 6px;
  text-align: left;
  cursor: pointer;
  min-height: 48px;
  transition: background 120ms ease-in-out, border-color 120ms ease-in-out,
    border-width 120ms ease-in-out;

  &.outside {
    opacity: 0.5;
  }
  &.disabled {
    color: ${({theme}) => theme.colors.grey.grey400};
    background: ${({theme}) => theme.colors.grey.grey20};
    cursor: default;
  }
  &.available {
    background: ${({theme}) => theme.colors.secondary.orange200};
    border-color: ${({theme}) => theme.colors.secondary.orange600};
  }
  &.selected {
    border-color: ${({theme}) => theme.colors.primary.main};
    border-width: 3.5px;
    box-shadow: 0 0 0 2px rgba(0, 42, 126, 0.2);
  }
  &:hover {
    background: ${({theme}) => theme.colors.grey.grey20};
  }
  &.available:hover {
    background: ${({theme}) => theme.colors.secondary.orange600};
  }
  .dateLabel {
    font-weight: 500;
    margin-bottom: 4px;
  }
  &.available .dateLabel {
    font-weight: 700;
  }
`

export const SlotsGrid = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
`

export const ReserveBar = styled(Container).attrs({
  justify: 'space-between',
  align: 'center',
})``

export const SlotButtonEx = styled.button`
  border: 1px solid ${({theme}) => theme.colors.inputBorder};
  background: ${({theme}) => theme.colors.white};
  border-radius: ${({theme}) => theme.borderRadius.xs};
  padding: 8px 12px;
  cursor: pointer;
  transition: background 120ms ease-in-out, border-color 120ms ease-in-out;

  &.selected {
    border-color: ${({theme}) => theme.colors.primary.main};
    background: ${({theme}) => theme.colors.primary.blue50};
  }
  &:hover {
    background: ${({theme}) => theme.colors.grey.grey40};
  }
`

export const BookButton = styled(Button)`
  border-radius: ${({theme}) => theme.borderRadius.xs};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  width: 100%;
  justify-content: center;

  &:hover {
    filter: brightness(0.97);
  }
`

// Single-line info banner for no-availability message
export const NoAvailabilityBanner = styled(Container).attrs({
  justify: 'center',
  align: 'center',
})`
  width: 100%;
  padding: 12px;
  background: ${({theme}) => theme.colors.grey.grey40};
  border: 1px solid ${({theme}) => theme.colors.inputBorder};
  border-radius: ${({theme}) => theme.borderRadius.xs};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

// Time zone notice below the grid
export const TimeZoneNotice = styled(Container).attrs({
  justify: 'center',
  align: 'center',
})`
  padding: 16px 0;
  color: ${({theme}) => theme.colors.grey.main};
  margin-top: auto; /* Push notice to bottom inside DayCard */
`

// Highlight box for confirmation details
export const ConfirmHighlight = styled(Container).attrs({
  direction: 'column',
  spacing: 1,
})`
  padding: 12px;
  background: ${({theme}) => theme.colors.secondary.orange50};
  border: 1px solid ${({theme}) => theme.colors.secondary.orange200};
  border-radius: ${({theme}) => theme.borderRadius.xs};
`

// Powered by section (Cushla)
export const PoweredBySection = styled(Container).attrs({
  direction: 'column',
  align: 'center',
  justify: 'center',
  spacing: 1,
})`
  padding: 24px 0 48px;
  text-align: center;
`

export const PoweredByLogo = styled.img`
  height: 36px;
  width: auto;
  object-fit: contain;
  margin: 8px 0;
`

// Centered confirmation section replacing the main content after booking
export const ConfirmationSection = styled(Container).attrs({
  justify: 'center',
  align: 'center',
})`
  width: 100%;
  min-height: 40vh;
  padding: 24px 0;
  animation: fadeInUp 220ms ease-out;

  @keyframes fadeInUp {
    0% {
      opacity: 0;
      transform: translateY(8px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const ConfirmationCard = styled(Card)`
  padding: 20px;
  max-width: 640px;
  width: 100%;
  margin: 0 auto;
`
